import { render, staticRenderFns } from "./ReservationActions.vue?vue&type=template&id=ebd4ecf2&scoped=true&"
import script from "./ReservationActions.vue?vue&type=script&lang=js&"
export * from "./ReservationActions.vue?vue&type=script&lang=js&"
import style0 from "./ReservationActions.vue?vue&type=style&index=0&id=ebd4ecf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd4ecf2",
  null
  
)

export default component.exports